
export const AUTH_ACCESS = {

  dashboard: {
    ADMIN: [ 'ADMIN', 'AUDITOR', 'GROUP', 'AUDITED' ],
    USER: [ 'ADMIN', 'AUDITOR', 'GROUP', 'AUDITED' ]
  },

  profile: {
    ADMIN: [ 'ADMIN', 'AUDITOR', 'GROUP', 'AUDITED' ],
    USER: [ 'ADMIN', 'AUDITOR', 'GROUP', 'AUDITED' ]
  },

  // ENTERPRISES
  enterprises: {
    ADMIN: [ 'ADMIN', 'AUDITOR', 'GROUP', 'AUDITED' ],
    USER: [ 'ADMIN', 'AUDITOR', 'GROUP', 'AUDITED' ]
  },

  getMyEnterprise: {
    ADMIN: [ 'ADMIN', 'AUDITOR', 'GROUP', 'AUDITED' ],
    USER: [ 'ADMIN', 'AUDITOR', 'GROUP', 'AUDITED' ]
  },
  updateMyEnterprise: {
    ADMIN: [ 'ADMIN', 'AUDITOR', 'GROUP', 'AUDITED' ]
  },
  createMyUser: {
    ADMIN: [ 'ADMIN', 'AUDITOR', 'GROUP', 'AUDITED' ],
  },
  updateMyUser: {
    ADMIN: [ 'ADMIN', 'AUDITOR', 'GROUP', 'AUDITED' ],
  },
  deleteMyUser: {
    ADMIN: [ 'ADMIN', 'AUDITOR', 'GROUP', 'AUDITED' ],
  },

  getEnterprises: {
    ADMIN: [ 'ADMIN','AUDITOR' ],
    USER: [ 'ADMIN','AUDITOR' ]
  },
  createEnterprise: {
    ADMIN: [ 'ADMIN'],
    USER: [ 'ADMIN' ]
  },
  updateEnterprise: {
    ADMIN: [ 'ADMIN','AUDITOR'],
    USER: [ 'ADMIN' ]
  },
  updateEnterpriseType: {
    ADMIN: [ 'ADMIN' ]
  },
  updateEnterpriseIsDistributor: {
    ADMIN: [ 'ADMIN' ],
    USER: [ 'ADMIN' ]
  },
  createUserEnterprise: {
    ADMIN: ['ADMIN' ],
    USER: ['ADMIN']
  },
  updateUserEnterprise: {
    ADMIN: [ 'ADMIN' ],
    USER: [ 'ADMIN' ]
  },
  deleteEnterprise: {
    ADMIN: [ 'ADMIN' ]
  },
  deleteEnterpriseRelation: {
    ADMIN: [ 'ADMIN', 'AUDITOR' ],
    USER: [ 'ADMIN' ]
  },
  deleteUserEnterprise: {
    ADMIN: [ 'ADMIN' ],
    USER: [ 'ADMIN' ]
  },
  deepListing: {
    ADMIN: [ 'ADMIN' ],
    USER: [ 'ADMIN' ]
  },

  getEnterprisesAuditors: {
    ADMIN: [ 'AUDITED' ],
    USER: [ 'AUDITED' ]
  },
  getOneEnterpriseAuditor: {
    ADMIN: [ 'GROUP', 'AUDITED' ],
    USER: [ 'GROUP', 'AUDITED' ]
  },
  updateEnterpriseAuditor: {},
  createUserEnterpriseAuditor: {},
  updateUserEnterpriseAuditor: {},
  deleteUserEnterpriseAuditor: {},

  getEnterprisesEstablishments: {
    ADMIN: [ 'GROUP' ],
    USER: [ 'GROUP' ]
  },
  getOneEnterpriseEstablishment: {
    ADMIN: [ 'GROUP' ],
    USER: [ 'GROUP' ]
  },
  updateEnterpriseEstablishment: {
    ADMIN: [ 'GROUP' ]
  },
  createUserEnterpriseEstablishment: {
    ADMIN: [ 'GROUP' ]
  },
  updateUserEnterpriseEstablishment: {
    ADMIN: [ 'GROUP' ]
  },
  deleteUserEnterpriseEstablishment: {},

  getEnterprisesAudited: {
    ADMIN: [ 'AUDITOR' ],
    USER: [ 'AUDITOR' ]
  },
  getOneEnterpriseAudited: {
    ADMIN: [ 'AUDITOR' ],
    USER: [ 'AUDITOR' ]
  },
  updateEnterpriseAudited: {},
  createUserEnterpriseAudited: {
    ADMIN: ['AUDITOR']
  },
  updateUserEnterpriseAudited: {},
  deleteUserEnterpriseAudited: {
    ADMIN: [ 'AUDITOR' ],
  },

  getEnterprisesDistributed: {
    ADMIN: [ 'AUDITOR', 'GROUP', 'AUDITED' ],
    USER: [ 'AUDITOR', 'GROUP', 'AUDITED' ]
  },
  getOneEnterpriseDistributed: {
    ADMIN: [ 'AUDITOR', 'GROUP', 'AUDITED' ],
    USER: [ 'AUDITOR', 'GROUP', 'AUDITED' ]
  },
  updateEnterpriseDistributed: {},
  createUserEnterpriseDistributed: {
    ADMIN: [ 'AUDITOR', 'GROUP', 'AUDITED' ],
    USER: [ 'AUDITOR', 'GROUP', 'AUDITED' ]
  },
  updateUserEnterpriseDistributed: {
    ADMIN: [ 'AUDITOR', 'GROUP', 'AUDITED' ],
    USER: [ 'AUDITOR', 'GROUP', 'AUDITED' ]
  },
  deleteUserEnterpriseDistributed: {
    ADMIN: [ 'AUDITOR', 'GROUP', 'AUDITED' ]
  },
  // ENTERPRISES END

  // FRAMES
  frames: {
    ADMIN: [ 'ADMIN', 'AUDITOR', 'GROUP', 'AUDITED' ],
    USER: [ 'ADMIN', 'AUDITOR', 'GROUP', 'AUDITED' ]
  },
  archivedFrames: {
    ADMIN: [ 'ADMIN', 'AUDITOR', 'GROUP', 'AUDITED' ],
    USER: [ 'ADMIN', 'AUDITOR', 'GROUP', 'AUDITED' ]
  },
  restoreFrame: {
    ADMIN: [ 'ADMIN', 'AUDITOR', 'GROUP', 'AUDITED' ],
    USER: [ 'ADMIN', 'AUDITOR', 'GROUP', 'AUDITED' ]
  },
  frame: {
    ADMIN: [ 'ADMIN', 'AUDITOR', 'GROUP', 'AUDITED' ],
    USER: [ 'ADMIN', 'AUDITOR', 'GROUP', 'AUDITED' ]
  },
  catalogFrames: {
    ADMIN: [ 'ADMIN', 'AUDITOR', 'GROUP', 'AUDITED' ],
    USER: [ 'ADMIN', 'AUDITOR', 'GROUP', 'AUDITED' ]
  },
  exportFrame: {
    ADMIN: [ 'ADMIN', 'AUDITOR', 'GROUP', 'AUDITED' ],
    USER: [ 'ADMIN' ]
  },
  createFrame: {
    ADMIN: [ 'ADMIN', 'AUDITOR', 'GROUP', 'AUDITED' ],
    USER: [ 'ADMIN' ]
  },
  updateFrame: {
    ADMIN: [ 'ADMIN', 'AUDITOR', 'GROUP', 'AUDITED' ],
    USER: [ 'ADMIN' ]
  },
  archiveFrame: {
    ADMIN: [ 'ADMIN', 'AUDITOR', 'GROUP', 'AUDITED' ],
    USER: [ 'ADMIN' ]
  },
  deleteFrame: {
    ADMIN: [ 'ADMIN', 'AUDITOR', 'GROUP', 'AUDITED' ],
    USER: [ 'ADMIN' ]
  },
  buyFrame: {
    ADMIN: [ 'AUDITOR', 'AUDITOR', 'AUDITED' ],
    USER: [ 'AUDITOR', 'AUDITOR', 'AUDITED' ]
  },
  // FRAMES END

  // AUDITS
  audits: {
    ADMIN: [ 'AUDITOR', 'GROUP', 'AUDITED' ],
    USER: [ 'AUDITOR', 'GROUP', 'AUDITED' ]
  },
  auditsPerformed: {
    ADMIN: [ 'AUDITOR', 'GROUP', 'AUDITED' ],
    USER: [ 'AUDITOR', 'GROUP', 'AUDITED' ]
  },
  auditsPerformedDraft: {
    ADMIN: [ 'AUDITOR', 'GROUP', 'AUDITED' ],
    USER: [ 'AUDITOR', 'GROUP', 'AUDITED' ]
  },
  auditsPerformedWaiting: {
    ADMIN: [ 'AUDITOR', 'GROUP', 'AUDITED' ],
    USER: [ 'AUDITOR', 'GROUP', 'AUDITED' ]
  },
  auditsPerformedValidated: {
    ADMIN: [ 'AUDITOR', 'GROUP', 'AUDITED' ],
    USER: [ 'AUDITOR', 'GROUP', 'AUDITED' ]
  },
  auditDownloadPdf: {
    ADMIN: [ 'AUDITOR', 'GROUP', 'AUDITED' ],
    USER: [ 'AUDITOR', 'GROUP', 'AUDITED' ]
  },
  auditDownloadActionPlanXlsx: {
    ADMIN: [ 'AUDITOR', 'GROUP', 'AUDITED' ],
    USER: [ 'AUDITOR', 'GROUP', 'AUDITED' ]
  },
  auditsInternal: {
    ADMIN: [ 'GROUP', 'AUDITED' ],
    USER: [ 'GROUP', 'AUDITED' ]
  },
  auditsInternalDraft: {
    ADMIN: [ 'GROUP', 'AUDITED' ],
    USER: [ 'GROUP', 'AUDITED' ]
  },
  auditsInternalWaiting: {
    ADMIN: [ 'GROUP', 'AUDITED' ],
    USER: [ 'GROUP', 'AUDITED' ]
  },
  auditsInternalValidated: {
    ADMIN: [ 'GROUP', 'AUDITED' ],
    USER: [ 'GROUP', 'AUDITED' ]
  },
  deleteAudit: {
    ADMIN: [ 'ADMIN', 'AUDITOR', 'GROUP', 'AUDITED' ],
    USER: [ 'ADMIN' ]
  },
  deleteAuditDraft: {
    ADMIN: [ 'ADMIN', 'AUDITOR', 'GROUP', 'AUDITED' ],
    USER: [ 'ADMIN', 'AUDITOR', 'GROUP', 'AUDITED' ]
  },
  createAudit: {
    ADMIN: [ 'ADMIN', 'AUDITOR', 'GROUP', 'AUDITED' ],
    USER: [ 'ADMIN', 'AUDITOR', 'AUDITED', 'GROUP' ]
  },
  editAudit: {
    ADMIN: [ 'ADMIN', 'AUDITOR', 'AUDITED', 'GROUP' ],
    USER: [ 'ADMIN', 'AUDITOR', 'AUDITED', 'GROUP' ]
  },
  editAuditPicture: {
    ADMIN: [ 'ADMIN', 'AUDITOR', 'AUDITED', 'GROUP' ],
    USER: [ 'ADMIN', 'AUDITOR', 'AUDITED', 'GROUP' ]
  },
  editDraftAudit: {
    ADMIN: [ 'ADMIN', 'AUDITOR', 'AUDITED', 'GROUP' ],
    USER: [ 'ADMIN', 'AUDITOR', 'AUDITED', 'GROUP' ]
  },
  editDraftAuditPicture: {
    ADMIN: [ 'ADMIN', 'AUDITOR', 'AUDITED', 'GROUP' ],
    USER: [ 'ADMIN', 'AUDITOR', 'AUDITED', 'GROUP' ]
  },
  editValidatedAudit: {
    ADMIN: [ 'ADMIN', 'AUDITOR', 'AUDITED' ],
    USER: [ 'ADMIN' ]
  },
  editWaitingAudit: {
    ADMIN: [ 'ADMIN', 'AUDITOR', 'AUDITED' ],
    USER: [ 'ADMIN' ]
  },
  cloneAudit: {
    ADMIN: [ 'ADMIN', 'AUDITOR', 'AUDITED' ],
    USER: [ 'ADMIN' ]
  },
  resetAuditToDraft: {
    ADMIN: [ 'ADMIN', 'AUDITOR', 'GROUP', 'AUDITED' ],
  },

  exportAudit: {
    ADMIN: [ 'ADMIN', 'AUDITOR', 'AUDITED', 'GROUP' ],
  },
  // AUDITS END

  // ACTION PLANS
  plans: {
    ADMIN: [ 'ADMIN', 'AUDITOR', 'GROUP', 'AUDITED' ],
    USER: [ 'ADMIN', 'AUDITOR', 'GROUP', 'AUDITED' ],
    GUEST: [ 'ADMIN', 'AUDITOR', 'GROUP', 'AUDITED' ]
  },
  plansAchieved: {
    ADMIN: [ 'ADMIN', 'AUDITOR', 'GROUP', 'AUDITED' ],
    USER: [ 'ADMIN', 'AUDITOR', 'GROUP', 'AUDITED' ],
    GUEST: [ 'ADMIN', 'AUDITOR', 'GROUP', 'AUDITED' ]
  },
  plansProgress: {
    ADMIN: [ 'ADMIN', 'AUDITOR', 'GROUP', 'AUDITED' ],
    USER: [ 'ADMIN', 'AUDITOR', 'GROUP', 'AUDITED' ],
    GUEST: [ 'ADMIN', 'AUDITOR', 'GROUP', 'AUDITED' ]
  },
  plansScheduled: {
    ADMIN: [ 'ADMIN', 'AUDITOR', 'GROUP', 'AUDITED' ],
    USER: [ 'ADMIN', 'AUDITOR', 'GROUP', 'AUDITED' ],
    GUEST: [ 'ADMIN', 'AUDITOR', 'GROUP', 'AUDITED' ]
  },
  // ACTION PLANS END

  // PLANNING
  planning: {
    ADMIN: [ 'AUDITOR', 'GROUP', 'AUDITED' ],
    USER: [ 'AUDITOR', 'GROUP', 'AUDITED' ]
  },
  myPlanning: {
    ADMIN: [ 'AUDITOR', 'GROUP', 'AUDITED' ],
    USER: [ 'AUDITOR', 'GROUP', 'AUDITED' ]
  },
  myEnterprisePlanning: {
    ADMIN: [ 'AUDITOR', 'GROUP', 'AUDITED' ]
  },
  createPlanning: {
    ADMIN: [ 'AUDITOR', 'GROUP' ]
  },
  // PLANNING END

  // USERS
  getAllUsers: {
    ADMIN: [ 'ADMIN' ],
    USER: [ 'ADMIN' ]
  },
  getArchivedUsers: {
    ADMIN: [ 'ADMIN' ],
    USER: [ 'ADMIN' ]
  },
  restoreUser: {
    ADMIN: [ 'ADMIN' ],
    USER: [ 'ADMIN' ]
  },
  getUsers: {
    ADMIN: [ 'ADMIN', 'AUDITOR', 'GROUP', 'AUDITED' ],
    USER: [ 'ADMIN', 'AUDITOR', 'GROUP', 'AUDITED' ]
  },
  createUser: {
    ADMIN: ['ADMIN', 'AUDITOR', 'GROUP', 'AUDITED'],
    USER: ['ADMIN']
  },
  updateUser: {
    ADMIN: [ 'ADMIN', 'AUDITOR', 'GROUP', 'AUDITED' ],
    USER: [ 'ADMIN' ]
  },
  deleteUser: {
    ADMIN: ['ADMIN', 'AUDITOR', 'GROUP', 'AUDITED'],
    USER: [ 'ADMIN' ]
  },
  // USERS END
};



// WEBPACK FOOTER //
// /home/web_clients/qualicheck.fr/preprod/erp/src/app/core/auth/auth.access.ts